const Home = () => import('../views/Home.vue');
const About = () => import('../views/About.vue');
const Contacts = () => import('../views/Contacts.vue');
const Search = () => import('../views/Search.vue');
const Catalog = () => import('../views/Catalog.vue');
const CatalogCard = () => import('../views/CatalogCard.vue');
const CatalogItem = () => import('../views/CatalogItem.vue');

export default [
  {
    path: '/',
    component: Home,
    name: 'home',
  },
  {
    path: '/about',
    component: About,
    name: 'about',
  },
  {
    path: '/contacts',
    component: Contacts,
    name: 'contacts',
  },
  {
    path: '/search',
    component: Search,
    name: 'search',
    props: (route) => ({ query: route.query.query }),
  },
  {
    path: '/:categorySlug?',
    component: Catalog,
    name: 'category',
    children: [
      {
        path: 'products',
        component: CatalogItem,
        name: 'products',
        children: [
          {
            path: ':productSlug',
            component: CatalogCard,
            name: 'product',
          },
        ]
      },
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/home',
  }
];
